import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Problema() {
  const problemas = ['Jugás hace meses y sentís que tu zurda no mejora', 'Siempre te limitan a jugar solo por el lado izquierdo', 'No sabés cómo aprovechar tu pierna zurda tácticamente', 'Tus rivales se adaptan rápido a tu juego zurdo', 'Perdés goles por falta de técnica con la izquierda', 'Nadie te enseñó a jugar como zurdo en fútbol 5'];
  return <section className="py-16 bg-navy relative border-t border-white/5" data-id="element-224">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-225">
        <FadeIn data-id="element-226">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-10 uppercase text-white" data-id="element-227">
            ¿Te pasa alguna de{' '}
            <span className="text-red-500" data-id="element-228">estas situaciones?</span>
          </h2>
        </FadeIn>

        <div className="grid gap-3 mb-12" data-id="element-229">
          {problemas.map((prob, idx) => <FadeIn key={idx} delay={idx * 0.1} direction="up" data-id="element-230">
              <div className="bg-row1 border border-white/5 p-5 rounded-xl flex items-center gap-4 hover:bg-row2 transition-colors" data-id="element-231">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0" data-id="element-232" />
                <p className="text-base md:text-lg font-medium text-gray-200" data-id="element-233">
                  {prob}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-234">
          <div className="bg-row1 border-l-4 border-celeste p-8 rounded-r-xl shadow-2xl relative overflow-hidden" data-id="element-235">
            <div className="absolute top-0 right-0 w-32 h-32 bg-celeste/10 blur-3xl rounded-full" data-id="element-236"></div>
            <p className="text-xl md:text-2xl font-bold leading-relaxed relative z-10 italic text-white" data-id="element-237">
              "La mayoría de los zurdos amateur pierde partidos porque{' '}
              <span className="text-celeste" data-id="element-238">
                nadie les enseñó a usar su mayor ventaja.
              </span>
              "
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}